//@ts-check

/** @type import("../../types/icons/glyphs").Glyphs */

export default {
  "abort": {
    code: "f000",
    aliases: [],
    file: "horizon/abort.svg",
  },
  "ac-action-didntclicklink": {
    code: "f001",
    aliases: [],
    file: "horizon/ac/ac-action-didntclicklink.svg",
  },
  "ac-action-didntrespond": {
    code: "f002",
    aliases: [],
    file: "horizon/ac/ac-action-didntrespond.svg",
  },
  "ac-action-email": {
    code: "f003",
    aliases: [],
    file: "horizon/ac/ac-action-email.svg",
  },
  "ac-action-exclusionfilter": {
    code: "f004",
    aliases: [],
    file: "horizon/ac/ac-action-exclusionfilter.svg",
  },
  "ac-action-export": {
    code: "f005",
    aliases: [],
    file: "horizon/ac/ac-action-export.svg",
  },
  "ac-action-filter": {
    code: "f006",
    aliases: [],
    file: "horizon/ac/ac-action-filter.svg",
  },
  "ac-action-filterswitch": {
    code: "f007",
    aliases: [],
    file: "horizon/ac/ac-action-filterswitch.svg",
  },
  "ac-action-finish": {
    code: "f008",
    aliases: [],
    file: "horizon/ac/ac-action-finish.svg",
  },
  "ac-action-schedule": {
    code: "f009",
    aliases: [],
    file: "horizon/ac/ac-action-schedule.svg",
  },
  "ac-action-simplefilter": {
    code: "f00a",
    aliases: [],
    file: "horizon/ac/ac-action-simplefilter.svg",
  },
  "ac-action-sms": {
    code: "f00b",
    aliases: [],
    file: "horizon/ac/ac-action-sms.svg",
  },
  "ac-action-splitter": {
    code: "f00c",
    aliases: [],
    file: "horizon/ac/ac-action-splitter.svg",
  },
  "ac-action-timer": {
    code: "f00d",
    aliases: [],
    file: "horizon/ac/ac-action-timer.svg",
  },
  "ac-add_to_facebook_audience": {
    code: "f00e",
    aliases: [],
    file: "horizon/ac/ac-add_to_facebook_audience.svg",
  },
  "ac-api_gnl1": {
    code: "f00f",
    aliases: [],
    file: "horizon/ac/ac-api_gnl1.svg",
  },
  "ac-api_gnl2": {
    code: "f010",
    aliases: [],
    file: "horizon/ac/ac-api_gnl2.svg",
  },
  "ac-arrow_left": {
    code: "f011",
    aliases: [],
    file: "horizon/ac/ac-arrow_left.svg",
  },
  "ac-arrow_right": {
    code: "f012",
    aliases: [],
    file: "horizon/ac/ac-arrow_right.svg",
  },
  "ac-audience_exchange_add": {
    code: "f013",
    aliases: [],
    file: "horizon/ac/ac-audience_exchange_add.svg",
  },
  "ac-audience_exchange_remove": {
    code: "f014",
    aliases: [],
    file: "horizon/ac/ac-audience_exchange_remove.svg",
  },
  "ac-birthday": {
    code: "f015",
    aliases: [],
    file: "horizon/ac/ac-birthday.svg",
  },
  "ac-cart_outline": {
    code: "f016",
    aliases: [],
    file: "horizon/ac/ac-cart_outline.svg",
  },
  "ac-condition-check": {
    code: "f017",
    aliases: [],
    file: "horizon/ac/ac-condition-check.svg",
  },
  "ac-condition-cross": {
    code: "f018",
    aliases: [],
    file: "horizon/ac/ac-condition-cross.svg",
  },
  "ac-connected-program": {
    code: "f019",
    aliases: [],
    file: "horizon/ac/ac-connected-program.svg",
  },
  "ac-contacts-delete": {
    code: "f01a",
    aliases: [],
    file: "horizon/ac/ac-contacts-delete.svg",
  },
  "ac-contacts_export": {
    code: "f01b",
    aliases: [],
    file: "horizon/ac/ac-contacts_export.svg",
  },
  "ac-crm-ads-add": {
    code: "f01c",
    aliases: [],
    file: "horizon/ac/ac-crm-ads-add.svg",
  },
  "ac-crm-ads-remove": {
    code: "f01d",
    aliases: [],
    file: "horizon/ac/ac-crm-ads-remove.svg",
  },
  "ac-direct_mail": {
    code: "f01e",
    aliases: [],
    file: "horizon/ac/ac-direct_mail.svg",
  },
  "ac-doi": {
    code: "f01f",
    aliases: [],
    file: "horizon/ac/ac-doi.svg",
  },
  "ac-ecrebo": {
    code: "f020",
    aliases: [],
    file: "horizon/ac/ac-ecrebo.svg",
  },
  "ac-engagement_optimization": {
    code: "f021",
    aliases: [],
    file: "horizon/ac/ac-engagement_optimization.svg",
  },
  "ac-entry-abandonedcart": {
    code: "f022",
    aliases: [],
    file: "horizon/ac/ac-entry-abandonedcart.svg",
  },
  "ac-entry-connect-program": {
    code: "f023",
    aliases: [],
    file: "horizon/ac/ac-entry-connect-program.svg",
  },
  "ac-entry-datachange": {
    code: "f024",
    aliases: [],
    file: "horizon/ac/ac-entry-datachange.svg",
  },
  "ac-entry-externalevent": {
    code: "f025",
    aliases: [],
    file: "horizon/ac/ac-entry-externalevent.svg",
  },
  "ac-entry-form": {
    code: "f026",
    aliases: [],
    file: "horizon/ac/ac-entry-form.svg",
  },
  "ac-entry-massemail": {
    code: "f027",
    aliases: [],
    file: "horizon/ac/ac-entry-massemail.svg",
  },
  "ac-entry-newcontact-shopify": {
    code: "f028",
    aliases: [],
    file: "horizon/ac/ac-entry-newcontact-shopify.svg",
  },
  "ac-entry-newcontact": {
    code: "f029",
    aliases: [],
    file: "horizon/ac/ac-entry-newcontact.svg",
  },
  "ac-entry-recipients": {
    code: "f02a",
    aliases: [],
    file: "horizon/ac/ac-entry-recipients.svg",
  },
  "ac-entry-recurringfilter": {
    code: "f02b",
    aliases: [],
    file: "horizon/ac/ac-entry-recurringfilter.svg",
  },
  "ac-entry-recurringmassemail": {
    code: "f02c",
    aliases: [],
    file: "horizon/ac/ac-entry-recurringmassemail.svg",
  },
  "ac-entry-schedule": {
    code: "f02d",
    aliases: [],
    file: "horizon/ac/ac-entry-schedule.svg",
  },
  "ac-event-false": {
    code: "f02e",
    aliases: [],
    file: "horizon/ac/ac-event-false.svg",
  },
  "ac-event-true": {
    code: "f02f",
    aliases: [],
    file: "horizon/ac/ac-event-true.svg",
  },
  "ac-finish-connect-program": {
    code: "f030",
    aliases: [],
    file: "horizon/ac/ac-finish-connect-program.svg",
  },
  "ac-google": {
    code: "f031",
    aliases: [],
    file: "horizon/ac/ac-google.svg",
  },
  "ac-googlead_add": {
    code: "f032",
    aliases: [],
    file: "horizon/ac/ac-googlead_add.svg",
  },
  "ac-googlead_remove": {
    code: "f033",
    aliases: [],
    file: "horizon/ac/ac-googlead_remove.svg",
  },
  "ac-icon-info": {
    code: "f034",
    aliases: [],
    file: "horizon/ac/ac-icon-info.svg",
  },
  "ac-icon_calendar": {
    code: "f035",
    aliases: [],
    file: "horizon/ac/ac-icon_calendar.svg",
  },
  "ac-icon_calendar_small": {
    code: "f036",
    aliases: [],
    file: "horizon/ac/ac-icon_calendar_small.svg",
  },
  "ac-icon_calendar_small_white": {
    code: "f037",
    aliases: [],
    file: "horizon/ac/ac-icon_calendar_small_white.svg",
  },
  "ac-icon_connect": {
    code: "f038",
    aliases: [],
    file: "horizon/ac/ac-icon_connect.svg",
  },
  "ac-icon_copy": {
    code: "f039",
    aliases: [],
    file: "horizon/ac/ac-icon_copy.svg",
  },
  "ac-icon_delete": {
    code: "f03a",
    aliases: [],
    file: "horizon/ac/ac-icon_delete.svg",
  },
  "ac-icon_down_arrow": {
    code: "f03b",
    aliases: [],
    file: "horizon/ac/ac-icon_down_arrow.svg",
  },
  "ac-icon_edit": {
    code: "f03c",
    aliases: [],
    file: "horizon/ac/ac-icon_edit.svg",
  },
  "ac-icon_forward": {
    code: "f03d",
    aliases: [],
    file: "horizon/ac/ac-icon_forward.svg",
  },
  "ac-icon_help": {
    code: "f03e",
    aliases: [],
    file: "horizon/ac/ac-icon_help.svg",
  },
  "ac-icon_info": {
    code: "f03f",
    aliases: [],
    file: "horizon/ac/ac-icon_info.svg",
  },
  "ac-icon_participation": {
    code: "f040",
    aliases: [],
    file: "horizon/ac/ac-icon_participation.svg",
  },
  "ac-icon_paste": {
    code: "f041",
    aliases: [],
    file: "horizon/ac/ac-icon_paste.svg",
  },
  "ac-icon_pipe": {
    code: "f042",
    aliases: [],
    file: "horizon/ac/ac-icon_pipe.svg",
  },
  "ac-icon_revert": {
    code: "f043",
    aliases: [],
    file: "horizon/ac/ac-icon_revert.svg",
  },
  "ac-icon_save": {
    code: "f044",
    aliases: [],
    file: "horizon/ac/ac-icon_save.svg",
  },
  "ac-icon_setting": {
    code: "f045",
    aliases: [],
    file: "horizon/ac/ac-icon_setting.svg",
  },
  "ac-icon_zoomfit": {
    code: "f046",
    aliases: [],
    file: "horizon/ac/ac-icon_zoomfit.svg",
  },
  "ac-icon_zoomin": {
    code: "f047",
    aliases: [],
    file: "horizon/ac/ac-icon_zoomin.svg",
  },
  "ac-icon_zoomout": {
    code: "f048",
    aliases: [],
    file: "horizon/ac/ac-icon_zoomout.svg",
  },
  "ac-inbox": {
    code: "f049",
    aliases: [],
    file: "horizon/ac/ac-inbox.svg",
  },
  "ac-mail2print": {
    code: "f04a",
    aliases: [],
    file: "horizon/ac/ac-mail2print.svg",
  },
  "ac-message-false": {
    code: "f04b",
    aliases: [],
    file: "horizon/ac/ac-message-false.svg",
  },
  "ac-message-true": {
    code: "f04c",
    aliases: [],
    file: "horizon/ac/ac-message-true.svg",
  },
  "ac-messengerpeople": {
    code: "f04d",
    aliases: [],
    file: "horizon/ac/ac-messengerpeople.svg",
  },
  "ac-mobile-slash": {
    code: "f04e",
    aliases: [],
    file: "horizon/ac/ac-mobile-slash.svg",
  },
  "ac-mobile": {
    code: "f04f",
    aliases: [],
    file: "horizon/ac/ac-mobile.svg",
  },
  "ac-nameday": {
    code: "f050",
    aliases: [],
    file: "horizon/ac/ac-nameday.svg",
  },
  "ac-new_channel": {
    code: "f051",
    aliases: [],
    file: "horizon/ac/ac-new_channel.svg",
  },
  "ac-offline_mail": {
    code: "f052",
    aliases: [],
    file: "horizon/ac/ac-offline_mail.svg",
  },
  "ac-on_data_change_alternative": {
    code: "f053",
    aliases: [],
    file: "horizon/ac/ac-on_data_change_alternative.svg",
  },
  "ac-programmatic_retention": {
    code: "f054",
    aliases: [],
    file: "horizon/ac/ac-programmatic_retention.svg",
  },
  "ac-push_notification": {
    code: "f055",
    aliases: [],
    file: "horizon/ac/ac-push_notification.svg",
  },
  "ac-pushwoosh": {
    code: "f056",
    aliases: [],
    file: "horizon/ac/ac-pushwoosh.svg",
  },
  "ac-response-abandonedcart": {
    code: "f057",
    aliases: [],
    file: "horizon/ac/ac-response-abandonedcart.svg",
  },
  "ac-salesforce": {
    code: "f058",
    aliases: [],
    file: "horizon/ac/ac-salesforce.svg",
  },
  "ac-select-branch": {
    code: "f059",
    aliases: [],
    file: "horizon/ac/ac-select-branch.svg",
  },
  "ac-select-multiple": {
    code: "f05a",
    aliases: [],
    file: "horizon/ac/ac-select-multiple.svg",
  },
  "ac-settings-anytime": {
    code: "f05b",
    aliases: [],
    file: "horizon/ac/ac-settings-anytime.svg",
  },
  "ac-settings-immediate": {
    code: "f05c",
    aliases: [],
    file: "horizon/ac/ac-settings-immediate.svg",
  },
  "ac-settings-indefinite": {
    code: "f05d",
    aliases: [],
    file: "horizon/ac/ac-settings-indefinite.svg",
  },
  "ac-settings-once": {
    code: "f05e",
    aliases: [],
    file: "horizon/ac/ac-settings-once.svg",
  },
  "ac-settings-repeat": {
    code: "f05f",
    aliases: [],
    file: "horizon/ac/ac-settings-repeat.svg",
  },
  "ac-sms": {
    code: "f060",
    aliases: [],
    file: "horizon/ac/ac-sms.svg",
  },
  "ac-socialad_add": {
    code: "f061",
    aliases: [],
    file: "horizon/ac/ac-socialad_add.svg",
  },
  "ac-socialad_remove": {
    code: "f062",
    aliases: [],
    file: "horizon/ac/ac-socialad_remove.svg",
  },
  "ac-switch_node": {
    code: "f063",
    aliases: [],
    file: "horizon/ac/ac-switch_node.svg",
  },
  "ac-testing": {
    code: "f064",
    aliases: [],
    file: "horizon/ac/ac-testing.svg",
  },
  "ac-transfer-connect-program": {
    code: "f065",
    aliases: [],
    file: "horizon/ac/ac-transfer-connect-program.svg",
  },
  "ac-trigger_api": {
    code: "f066",
    aliases: [],
    file: "horizon/ac/ac-trigger_api.svg",
  },
  "ac-value_control": {
    code: "f067",
    aliases: [],
    file: "horizon/ac/ac-value_control.svg",
  },
  "ac-web": {
    code: "f068",
    aliases: [],
    file: "horizon/ac/ac-web.svg",
  },
  "ac-web_add": {
    code: "f069",
    aliases: [],
    file: "horizon/ac/ac-web_add.svg",
  },
  "ac-web_remove": {
    code: "f06a",
    aliases: [],
    file: "horizon/ac/ac-web_remove.svg",
  },
  "ac-webpush": {
    code: "f06b",
    aliases: [],
    file: "horizon/ac/ac-webpush.svg",
  },
  "ac-wechat": {
    code: "f06c",
    aliases: [],
    file: "horizon/ac/ac-wechat.svg",
  },
  "ac": {
    code: "f06d",
    aliases: [],
    file: "horizon/ac.svg",
  },
  "accessibility": {
    code: "f06e",
    aliases: [],
    file: "horizon/accessibility.svg",
  },
  "addon-add": {
    code: "f06f",
    aliases: [],
    file: "horizon/addon-add.svg",
  },
  "addon": {
    code: "f070",
    aliases: [],
    file: "horizon/addon.svg",
  },
  "align-center": {
    code: "f071",
    aliases: [],
    file: "horizon/align-center.svg",
  },
  "align-left": {
    code: "f072",
    aliases: [],
    file: "horizon/align-left.svg",
  },
  "align-right": {
    code: "f073",
    aliases: [],
    file: "horizon/align-right.svg",
  },
  "angle-double-down": {
    code: "f074",
    aliases: [],
    file: "horizon/angle-double-down.svg",
  },
  "angle-double-left": {
    code: "f075",
    aliases: [],
    file: "horizon/angle-double-left.svg",
  },
  "angle-double-right": {
    code: "f076",
    aliases: [],
    file: "horizon/angle-double-right.svg",
  },
  "angle-double-up": {
    code: "f077",
    aliases: [],
    file: "horizon/angle-double-up.svg",
  },
  "angle-down": {
    code: "f078",
    aliases: [],
    file: "horizon/angle-down.svg",
  },
  "angle-up": {
    code: "f079",
    aliases: [],
    file: "horizon/angle-up.svg",
  },
  "api": {
    code: "f07a",
    aliases: [],
    file: "horizon/api.svg",
  },
  "arrow-down": {
    code: "f07b",
    aliases: [],
    file: "horizon/arrow-down.svg",
  },
  "arrow-right": {
    code: "f07c",
    aliases: ["long-arrow-right"],
    file: "horizon/arrow-right.svg",
  },
  "arrow-up": {
    code: "f07d",
    aliases: [],
    file: "horizon/arrow-up.svg",
  },
  "arrow": {
    code: "f07e",
    aliases: [],
    file: "horizon/arrow.svg",
  },
  "attr-first-touch": {
    code: "f07f",
    aliases: [],
    file: "horizon/attr-first-touch.svg",
  },
  "attr-last-touch": {
    code: "f080",
    aliases: [],
    file: "horizon/attr-last-touch.svg",
  },
  "attr-linear": {
    code: "f081",
    aliases: [],
    file: "horizon/attr-linear.svg",
  },
  "attr-time-decay": {
    code: "f082",
    aliases: [],
    file: "horizon/attr-time-decay.svg",
  },
  "ban": {
    code: "f083",
    aliases: [],
    file: "horizon/ban.svg",
  },
  "batch": {
    code: "f084",
    aliases: [],
    file: "horizon/batch.svg",
  },
  "bell": {
    code: "f085",
    aliases: [],
    file: "horizon/bell.svg",
  },
  "blocks": {
    code: "f086",
    aliases: [],
    file: "horizon/blocks.svg",
  },
  "bolt": {
    code: "f087",
    aliases: [],
    file: "horizon/bolt.svg",
  },
  "book": {
    code: "f088",
    aliases: [],
    file: "horizon/book.svg",
  },
  "briefcase": {
    code: "f089",
    aliases: ["account"],
    file: "horizon/briefcase.svg",
  },
  "bullhorn": {
    code: "f08a",
    aliases: [],
    file: "horizon/bullhorn.svg",
  },
  "calculator": {
    code: "f08b",
    aliases: [],
    file: "horizon/calculator.svg",
  },
  "calendar": {
    code: "f08c",
    aliases: ["calendar-o"],
    file: "horizon/calendar.svg",
  },
  "campaign-selector": {
    code: "f08d",
    aliases: ["campaign_selector"],
    file: "horizon/campaign-selector.svg",
  },
  "caret-double-down": {
    code: "f08e",
    aliases: [],
    file: "horizon/caret-double-down.svg",
  },
  "caret-double-up": {
    code: "f08f",
    aliases: [],
    file: "horizon/caret-double-up.svg",
  },
  "caret-down": {
    code: "f090",
    aliases: [],
    file: "horizon/caret-down.svg",
  },
  "caret-horizontal": {
    code: "f091",
    aliases: [],
    file: "horizon/caret-horizontal.svg",
  },
  "caret-left": {
    code: "f092",
    aliases: [],
    file: "horizon/caret-left.svg",
  },
  "caret-right": {
    code: "f093",
    aliases: [],
    file: "horizon/caret-right.svg",
  },
  "caret-up": {
    code: "f094",
    aliases: [],
    file: "horizon/caret-up.svg",
  },
  "caret-vertical": {
    code: "f095",
    aliases: [],
    file: "horizon/caret-vertical.svg",
  },
  "cart": {
    code: "f096",
    aliases: [],
    file: "horizon/cart.svg",
  },
  "celebrate": {
    code: "f097",
    aliases: [],
    file: "horizon/celebrate.svg",
  },
  "character-comma": {
    code: "f098",
    aliases: [],
    file: "horizon/character-comma.svg",
  },
  "character-pipe": {
    code: "f099",
    aliases: ["character-vertical-line"],
    file: "horizon/character-pipe.svg",
  },
  "character-semicolon": {
    code: "f09a",
    aliases: [],
    file: "horizon/character-semicolon.svg",
  },
  "chart-bar": {
    code: "f09b",
    aliases: ["bar-chart-vertical"],
    file: "horizon/chart-bar.svg",
  },
  "chart-column": {
    code: "f09c",
    aliases: ["bar-chart"],
    file: "horizon/chart-column.svg",
  },
  "chart-line": {
    code: "f09d",
    aliases: ["line-chart"],
    file: "horizon/chart-line.svg",
  },
  "checkbox-checked": {
    code: "f09e",
    aliases: [],
    file: "horizon/checkbox-checked.svg",
  },
  "checkbox-indeterminate": {
    code: "f09f",
    aliases: [],
    file: "horizon/checkbox-indeterminate.svg",
  },
  "checkbox-unchecked": {
    code: "f0a0",
    aliases: [],
    file: "horizon/checkbox-unchecked.svg",
  },
  "checkmark-circle": {
    code: "f0a1",
    aliases: ["check-circle"],
    file: "horizon/checkmark-circle.svg",
  },
  "checkmark": {
    code: "f0a2",
    aliases: ["check"],
    file: "horizon/checkmark.svg",
  },
  "chevron-circle-left": {
    code: "f0a3",
    aliases: [],
    file: "horizon/chevron-circle-left.svg",
  },
  "chevron-circle-right": {
    code: "f0a4",
    aliases: [],
    file: "horizon/chevron-circle-right.svg",
  },
  "clear": {
    code: "f0a5",
    aliases: [],
    file: "horizon/clear.svg",
  },
  "click-button": {
    code: "f0a6",
    aliases: [],
    file: "horizon/click-button.svg",
  },
  "click-rate-over-time": {
    code: "f0a7",
    aliases: ["click_rate_overtime"],
    file: "horizon/click-rate-over-time.svg",
  },
  "click-rate": {
    code: "f0a8",
    aliases: [],
    file: "horizon/click-rate.svg",
  },
  "clock": {
    code: "f0a9",
    aliases: ["clock-o"],
    file: "horizon/clock.svg",
  },
  "close-circle": {
    code: "f0aa",
    aliases: ["times-circle"],
    file: "horizon/close-circle.svg",
  },
  "close": {
    code: "f0ab",
    aliases: ["times"],
    file: "horizon/close.svg",
  },
  "cloud-upload": {
    code: "f0ac",
    aliases: [],
    file: "horizon/cloud-upload.svg",
  },
  "code": {
    code: "f0ad",
    aliases: [],
    file: "horizon/code.svg",
  },
  "combine": {
    code: "f0ae",
    aliases: [],
    file: "horizon/combine.svg",
  },
  "comment": {
    code: "f0af",
    aliases: ["commenting"],
    file: "horizon/comment.svg",
  },
  "communication-network": {
    code: "f0b0",
    aliases: [],
    file: "horizon/communication-network.svg",
  },
  "company": {
    code: "f0b1",
    aliases: [],
    file: "horizon/company.svg",
  },
  "compress": {
    code: "f0b2",
    aliases: [],
    file: "horizon/compress.svg",
  },
  "conditional-text": {
    code: "f0b3",
    aliases: ["conditional_text"],
    file: "horizon/conditional-text.svg",
  },
  "connect": {
    code: "f0b4",
    aliases: [],
    file: "horizon/connect.svg",
  },
  "contact-send": {
    code: "f0b5",
    aliases: [],
    file: "horizon/contact-send.svg",
  },
  "conversation": {
    code: "f0b6",
    aliases: [],
    file: "horizon/conversation.svg",
  },
  "currency-usd": {
    code: "f0b7",
    aliases: ["usd"],
    file: "horizon/currency-usd.svg",
  },
  "custom": {
    code: "f0b8",
    aliases: [],
    file: "horizon/custom.svg",
  },
  "dark": {
    code: "f0b9",
    aliases: [],
    file: "horizon/dark.svg",
  },
  "des-ac": {
    code: "f0ba",
    aliases: [],
    file: "horizon/des/des-ac.svg",
  },
  "des-check": {
    code: "f0bb",
    aliases: [],
    file: "horizon/des/des-check.svg",
  },
  "des-compare": {
    code: "f0bc",
    aliases: [],
    file: "horizon/des/des-compare.svg",
  },
  "des-deliver": {
    code: "f0bd",
    aliases: [],
    file: "horizon/des/des-deliver.svg",
  },
  "des-des": {
    code: "f0be",
    aliases: [],
    file: "horizon/des/des-des.svg",
  },
  "des-domains": {
    code: "f0bf",
    aliases: [],
    file: "horizon/des/des-domains.svg",
  },
  "des-quality": {
    code: "f0c0",
    aliases: [],
    file: "horizon/des/des-quality.svg",
  },
  "des-segmentation": {
    code: "f0c1",
    aliases: [],
    file: "horizon/des/des-segmentation.svg",
  },
  "des-trends": {
    code: "f0c2",
    aliases: [],
    file: "horizon/des/des-trends.svg",
  },
  "device-selector": {
    code: "f0c3",
    aliases: [],
    file: "horizon/device-selector.svg",
  },
  "distribute": {
    code: "f0c4",
    aliases: [],
    file: "horizon/distribute.svg",
  },
  "document-send": {
    code: "f0c5",
    aliases: ["send-document"],
    file: "horizon/document-send.svg",
  },
  "document-upload": {
    code: "f0c6",
    aliases: [],
    file: "horizon/document-upload.svg",
  },
  "download": {
    code: "f0c7",
    aliases: [],
    file: "horizon/download.svg",
  },
  "duplicate": {
    code: "f0c8",
    aliases: ["copy-block"],
    file: "horizon/duplicate.svg",
  },
  "edit-copy": {
    code: "f0c9",
    aliases: ["copy"],
    file: "horizon/edit-copy.svg",
  },
  "edit-cut": {
    code: "f0ca",
    aliases: ["cut"],
    file: "horizon/edit-cut.svg",
  },
  "edit-paste": {
    code: "f0cb",
    aliases: ["paste", "clipboard"],
    file: "horizon/edit-paste.svg",
  },
  "edit-redo": {
    code: "f0cc",
    aliases: ["redo"],
    file: "horizon/edit-redo.svg",
  },
  "edit-undo": {
    code: "f0cd",
    aliases: ["undo"],
    file: "horizon/edit-undo.svg",
  },
  "edit": {
    code: "f0ce",
    aliases: ["pencil"],
    file: "horizon/edit.svg",
  },
  "editable": {
    code: "f0cf",
    aliases: [],
    file: "horizon/editable.svg",
  },
  "email-block-based": {
    code: "f0d0",
    aliases: [],
    file: "horizon/email-block-based.svg",
  },
  "email-custom-html": {
    code: "f0d1",
    aliases: [],
    file: "horizon/email-custom-html.svg",
  },
  "email-preview": {
    code: "f0d2",
    aliases: [],
    file: "horizon/email-preview.svg",
  },
  "email-template-based": {
    code: "f0d3",
    aliases: [],
    file: "horizon/email-template-based.svg",
  },
  "empty": {
    code: "f0d4",
    aliases: [],
    file: "horizon/empty.svg",
  },
  "envelope": {
    code: "f0d5",
    aliases: ["email"],
    file: "horizon/envelope.svg",
  },
  "error": {
    code: "f0d6",
    aliases: [],
    file: "horizon/error.svg",
  },
  "event-send": {
    code: "f0d7",
    aliases: [],
    file: "horizon/event-send.svg",
  },
  "exclamation-circle": {
    code: "f0d8",
    aliases: ["exclamation-circle"],
    file: "horizon/exclamation-circle.svg",
  },
  "exclamation": {
    code: "f0d9",
    aliases: ["exclamation"],
    file: "horizon/exclamation.svg",
  },
  "expand": {
    code: "f0da",
    aliases: [],
    file: "horizon/expand.svg",
  },
  "externalevent": {
    code: "f0db",
    aliases: [],
    file: "horizon/externalevent.svg",
  },
  "eye-slash": {
    code: "f0dc",
    aliases: [],
    file: "horizon/eye-slash.svg",
  },
  "eye": {
    code: "f0dd",
    aliases: [],
    file: "horizon/eye.svg",
  },
  "fallback-text": {
    code: "f0de",
    aliases: ["fallback_text"],
    file: "horizon/fallback-text.svg",
  },
  "feature-ac": {
    code: "f0df",
    aliases: [],
    file: "horizon/feature-ac.svg",
  },
  "feature-billing-dashboard": {
    code: "f0e0",
    aliases: ["nav-billing-dashboard"],
    file: "horizon/feature-billing-dashboard.svg",
  },
  "feature-interactions": {
    code: "f0e1",
    aliases: [],
    file: "horizon/feature-interactions.svg",
  },
  "feature-predict": {
    code: "f0e2",
    aliases: ["predict"],
    file: "horizon/feature-predict.svg",
  },
  "feature-product-pioneer": {
    code: "f0e3",
    aliases: ["nav-product-pioneer-home"],
    file: "horizon/feature-product-pioneer.svg",
  },
  "feature-tactics": {
    code: "f0e4",
    aliases: [],
    file: "horizon/feature-tactics.svg",
  },
  "feedback": {
    code: "f0e5",
    aliases: [],
    file: "horizon/feedback.svg",
  },
  "file-bmp": {
    code: "f0e6",
    aliases: [],
    file: "horizon/file-bmp.svg",
  },
  "file-gif": {
    code: "f0e7",
    aliases: [],
    file: "horizon/file-gif.svg",
  },
  "file-gz": {
    code: "f0e8",
    aliases: [],
    file: "horizon/file-gz.svg",
  },
  "file-gzip": {
    code: "f0e9",
    aliases: [],
    file: "horizon/file-gzip.svg",
  },
  "file-ico": {
    code: "f0ea",
    aliases: [],
    file: "horizon/file-ico.svg",
  },
  "file-jpg": {
    code: "f0eb",
    aliases: [],
    file: "horizon/file-jpg.svg",
  },
  "file-js": {
    code: "f0ec",
    aliases: [],
    file: "horizon/file-js.svg",
  },
  "file-png": {
    code: "f0ed",
    aliases: [],
    file: "horizon/file-png.svg",
  },
  "file-rar": {
    code: "f0ee",
    aliases: [],
    file: "horizon/file-rar.svg",
  },
  "file-svg": {
    code: "f0ef",
    aliases: [],
    file: "horizon/file-svg.svg",
  },
  "file-text": {
    code: "f0f0",
    aliases: [],
    file: "horizon/file-text.svg",
  },
  "file-tga": {
    code: "f0f1",
    aliases: [],
    file: "horizon/file-tga.svg",
  },
  "file-zip": {
    code: "f0f2",
    aliases: [],
    file: "horizon/file-zip.svg",
  },
  "file": {
    code: "f0f3",
    aliases: ["file-file"],
    file: "horizon/file.svg",
  },
  "files": {
    code: "f0f4",
    aliases: ["files-o"],
    file: "horizon/files.svg",
  },
  "filter": {
    code: "f0f5",
    aliases: [],
    file: "horizon/filter.svg",
  },
  "finish": {
    code: "f0f6",
    aliases: [],
    file: "horizon/finish.svg",
  },
  "folder-create": {
    code: "f0f7",
    aliases: [],
    file: "horizon/folder-create.svg",
  },
  "folder-open": {
    code: "f0f8",
    aliases: [],
    file: "horizon/folder-open.svg",
  },
  "folder": {
    code: "f0f9",
    aliases: ["file-folder"],
    file: "horizon/folder.svg",
  },
  "format-bold": {
    code: "f0fa",
    aliases: ["bold"],
    file: "horizon/format-bold.svg",
  },
  "format-clear": {
    code: "f0fb",
    aliases: ["clear-format"],
    file: "horizon/format-clear.svg",
  },
  "format-heading": {
    code: "f0fc",
    aliases: ["header"],
    file: "horizon/format-heading.svg",
  },
  "format-italic": {
    code: "f0fd",
    aliases: ["italic"],
    file: "horizon/format-italic.svg",
  },
  "format-strikethrough": {
    code: "f0fe",
    aliases: ["strikethrough"],
    file: "horizon/format-strikethrough.svg",
  },
  "format-underline": {
    code: "f0ff",
    aliases: ["underline"],
    file: "horizon/format-underline.svg",
  },
  "frame-source": {
    code: "f100",
    aliases: ["frame_source"],
    file: "horizon/frame-source.svg",
  },
  "frame-style": {
    code: "f101",
    aliases: ["frame_style"],
    file: "horizon/frame-style.svg",
  },
  "frame-variables": {
    code: "f102",
    aliases: ["frame_variables"],
    file: "horizon/frame-variables.svg",
  },
  "freeze": {
    code: "f103",
    aliases: [],
    file: "horizon/freeze.svg",
  },
  "gavel": {
    code: "f104",
    aliases: [],
    file: "horizon/gavel.svg",
  },
  "general": {
    code: "f105",
    aliases: [],
    file: "horizon/general.svg",
  },
  "gift": {
    code: "f106",
    aliases: [],
    file: "horizon/gift.svg",
  },
  "hashtag": {
    code: "f107",
    aliases: [],
    file: "horizon/hashtag.svg",
  },
  "help": {
    code: "f108",
    aliases: ["helperlink", "nav-help", "nav-help-2x", "nav-online-help"],
    file: "horizon/help.svg",
  },
  "history": {
    code: "f109",
    aliases: [],
    file: "horizon/history.svg",
  },
  "home": {
    code: "f10a",
    aliases: [],
    file: "horizon/home.svg",
  },
  "image-broken": {
    code: "f10b",
    aliases: ["brokenimage"],
    file: "horizon/image-broken.svg",
  },
  "image-settings": {
    code: "f10c",
    aliases: [],
    file: "horizon/image-settings.svg",
  },
  "image": {
    code: "f10d",
    aliases: ["picture-o"],
    file: "horizon/image.svg",
  },
  "inbox": {
    code: "f10e",
    aliases: [],
    file: "horizon/inbox.svg",
  },
  "info-circle": {
    code: "f10f",
    aliases: [],
    file: "horizon/info-circle.svg",
  },
  "info": {
    code: "f110",
    aliases: [],
    file: "horizon/info.svg",
  },
  "key": {
    code: "f111",
    aliases: ["nav-share-account"],
    file: "horizon/key.svg",
  },
  "keyboard-return": {
    code: "f112",
    aliases: [],
    file: "horizon/keyboard-return.svg",
  },
  "keyboard-tab": {
    code: "f113",
    aliases: [],
    file: "horizon/keyboard-tab.svg",
  },
  "language": {
    code: "f114",
    aliases: [],
    file: "horizon/language.svg",
  },
  "life-ring": {
    code: "f115",
    aliases: [],
    file: "horizon/life-ring.svg",
  },
  "light": {
    code: "f116",
    aliases: [],
    file: "horizon/light.svg",
  },
  "link-broken": {
    code: "f117",
    aliases: ["chain-broken"],
    file: "horizon/link-broken.svg",
  },
  "link-external": {
    code: "f118",
    aliases: ["external-link"],
    file: "horizon/link-external.svg",
  },
  "link-overview": {
    code: "f119",
    aliases: ["link_overview"],
    file: "horizon/link-overview.svg",
  },
  "link-tracking": {
    code: "f11a",
    aliases: ["link_tracking"],
    file: "horizon/link-tracking.svg",
  },
  "link": {
    code: "f11b",
    aliases: [],
    file: "horizon/link.svg",
  },
  "list-add": {
    code: "f11c",
    aliases: [],
    file: "horizon/list-add.svg",
  },
  "list-remove": {
    code: "f11d",
    aliases: [],
    file: "horizon/list-remove.svg",
  },
  "lock": {
    code: "f11e",
    aliases: [],
    file: "horizon/lock.svg",
  },
  "logic-and": {
    code: "f11f",
    aliases: [],
    file: "horizon/logic-and.svg",
  },
  "logic-or": {
    code: "f120",
    aliases: [],
    file: "horizon/logic-or.svg",
  },
  "logo-android": {
    code: "f121",
    aliases: ["android"],
    file: "horizon/logo-android.svg",
  },
  "logo-apple": {
    code: "f122",
    aliases: ["apple"],
    file: "horizon/logo-apple.svg",
  },
  "logo-facebook": {
    code: "f123",
    aliases: ["facebook", "facebook-clr", "logo-facebook-clr"],
    file: "horizon/logo-facebook.svg",
  },
  "logo-google-plus": {
    code: "f124",
    aliases: ["google-plus"],
    file: "horizon/logo-google-plus.svg",
  },
  "logo-google": {
    code: "f125",
    aliases: ["google", "google-clr", "logo-google-clr"],
    file: "horizon/logo-google.svg",
  },
  "logo-jira": {
    code: "f126",
    aliases: ["jira"],
    file: "horizon/logo-jira.svg",
  },
  "logo-linkedin": {
    code: "f127",
    aliases: ["linkedin", "linkedin-clr", "logo-linkedin-clr"],
    file: "horizon/logo-linkedin.svg",
  },
  "logo-magento": {
    code: "f128",
    aliases: ["magento"],
    file: "horizon/logo-magento.svg",
  },
  "logo-sap": {
    code: "f129",
    aliases: [],
    file: "horizon/logo-sap.svg",
  },
  "logo-shopify": {
    code: "f12a",
    aliases: ["shopify"],
    file: "horizon/logo-shopify.svg",
  },
  "logo-tiktok": {
    code: "f12b",
    aliases: ["tiktok", "tiktok-clr", "logo-tiktok-clr"],
    file: "horizon/logo-tiktok.svg",
  },
  "logo-twitter": {
    code: "f12c",
    aliases: ["x", "twitter", "twitter-clr", "logo-twitter-clr"],
    file: "horizon/logo-twitter.svg",
  },
  "media-rich": {
    code: "f12d",
    aliases: [],
    file: "horizon/media-rich.svg",
  },
  "mediadb": {
    code: "f12e",
    aliases: [],
    file: "horizon/mediadb.svg",
  },
  "menu": {
    code: "f12f",
    aliases: ["bars"],
    file: "horizon/menu.svg",
  },
  "minus": {
    code: "f130",
    aliases: [],
    file: "horizon/minus.svg",
  },
  "mobile-settings": {
    code: "f131",
    aliases: [],
    file: "horizon/mobile-settings.svg",
  },
  "mobile-slash": {
    code: "f132",
    aliases: [],
    file: "horizon/mobile-slash.svg",
  },
  "mobile": {
    code: "f133",
    aliases: [],
    file: "horizon/mobile.svg",
  },
  "monitor": {
    code: "f134",
    aliases: ["monitor"],
    file: "horizon/monitor.svg",
  },
  "more-horizontal": {
    code: "f135",
    aliases: ["dots"],
    file: "horizon/more-horizontal.svg",
  },
  "move-bottom": {
    code: "f136",
    aliases: [],
    file: "horizon/move-bottom.svg",
  },
  "move-down": {
    code: "f137",
    aliases: [],
    file: "horizon/move-down.svg",
  },
  "move-left": {
    code: "f138",
    aliases: [],
    file: "horizon/move-left.svg",
  },
  "move-right": {
    code: "f139",
    aliases: [],
    file: "horizon/move-right.svg",
  },
  "move-top": {
    code: "f13a",
    aliases: [],
    file: "horizon/move-top.svg",
  },
  "move-up": {
    code: "f13b",
    aliases: [],
    file: "horizon/move-up.svg",
  },
  "move-vertical": {
    code: "f13c",
    aliases: [],
    file: "horizon/move-vertical.svg",
  },
  "move": {
    code: "f13d",
    aliases: [],
    file: "horizon/move.svg",
  },
  "movetoleft": {
    code: "f13e",
    aliases: [],
    file: "horizon/movetoleft.svg",
  },
  "movetoright": {
    code: "f13f",
    aliases: [],
    file: "horizon/movetoright.svg",
  },
  "nav-addons": {
    code: "f140",
    aliases: ["nav-addons-2x"],
    file: "horizon/nav-addons.svg",
  },
  "nav-analytics": {
    code: "f141",
    aliases: ["nav-analytics-2x"],
    file: "horizon/nav-analytics.svg",
  },
  "nav-automation": {
    code: "f142",
    aliases: ["nav-automation-2x"],
    file: "horizon/nav-automation.svg",
  },
  "nav-channels": {
    code: "f143",
    aliases: ["nav-channels-2x"],
    file: "horizon/nav-channels.svg",
  },
  "nav-contacts": {
    code: "f144",
    aliases: ["nav-contacts-2x"],
    file: "horizon/nav-contacts.svg",
  },
  "nav-content": {
    code: "f145",
    aliases: ["nav-content-2x"],
    file: "horizon/nav-content.svg",
  },
  "nav-featured": {
    code: "f146",
    aliases: ["nav-featured-2x"],
    file: "horizon/nav-featured.svg",
  },
  "nav-management": {
    code: "f147",
    aliases: ["nav-management-2x"],
    file: "horizon/nav-management.svg",
  },
  "other-contact": {
    code: "f148",
    aliases: ["other_contact"],
    file: "horizon/other-contact.svg",
  },
  "packages-add": {
    code: "f149",
    aliases: [],
    file: "horizon/packages-add.svg",
  },
  "packages": {
    code: "f14a",
    aliases: [],
    file: "horizon/packages.svg",
  },
  "pagebreak": {
    code: "f14b",
    aliases: [],
    file: "horizon/pagebreak.svg",
  },
  "panel-double": {
    code: "f14c",
    aliases: ["selector-dual"],
    file: "horizon/panel-double.svg",
  },
  "panel-single": {
    code: "f14d",
    aliases: ["selector-simple"],
    file: "horizon/panel-single.svg",
  },
  "paragraph": {
    code: "f14e",
    aliases: [],
    file: "horizon/paragraph.svg",
  },
  "pending": {
    code: "f14f",
    aliases: [],
    file: "horizon/pending.svg",
  },
  "personal": {
    code: "f150",
    aliases: [],
    file: "horizon/personal.svg",
  },
  "phone": {
    code: "f151",
    aliases: [],
    file: "horizon/phone.svg",
  },
  "playback-pause": {
    code: "f152",
    aliases: ["pause"],
    file: "horizon/playback-pause.svg",
  },
  "playback-play": {
    code: "f153",
    aliases: ["play"],
    file: "horizon/playback-play.svg",
  },
  "playback-stop": {
    code: "f154",
    aliases: ["stop"],
    file: "horizon/playback-stop.svg",
  },
  "plus": {
    code: "f155",
    aliases: [],
    file: "horizon/plus.svg",
  },
  "product-backinstock": {
    code: "f156",
    aliases: [],
    file: "horizon/product-backinstock.svg",
  },
  "product-pricedrop": {
    code: "f157",
    aliases: [],
    file: "horizon/product-pricedrop.svg",
  },
  "product": {
    code: "f158",
    aliases: [],
    file: "horizon/product.svg",
  },
  "productcatalog": {
    code: "f159",
    aliases: [],
    file: "horizon/productcatalog.svg",
  },
  "profile": {
    code: "f15a",
    aliases: ["nav-profile", "nav-profile-2x", "nav-my-profile"],
    file: "horizon/profile.svg",
  },
  "purchase": {
    code: "f15b",
    aliases: [],
    file: "horizon/purchase.svg",
  },
  "question-circle": {
    code: "f15c",
    aliases: [],
    file: "horizon/question-circle.svg",
  },
  "question": {
    code: "f15d",
    aliases: [],
    file: "horizon/question.svg",
  },
  "radio-checked": {
    code: "f15e",
    aliases: ["dot-circle-o"],
    file: "horizon/radio-checked.svg",
  },
  "radio-unchecked": {
    code: "f15f",
    aliases: [],
    file: "horizon/radio-unchecked.svg",
  },
  "refresh": {
    code: "f160",
    aliases: ["refresh"],
    file: "horizon/refresh.svg",
  },
  "rename": {
    code: "f161",
    aliases: [],
    file: "horizon/rename.svg",
  },
  "reorder": {
    code: "f162",
    aliases: ["move-reorder"],
    file: "horizon/reorder.svg",
  },
  "replace": {
    code: "f163",
    aliases: [],
    file: "horizon/replace.svg",
  },
  "reset": {
    code: "f164",
    aliases: ["reset-block"],
    file: "horizon/reset.svg",
  },
  "revenue-sd": {
    code: "f165",
    aliases: [],
    file: "horizon/revenue-sd.svg",
  },
  "revenue": {
    code: "f166",
    aliases: [],
    file: "horizon/revenue.svg",
  },
  "review": {
    code: "f167",
    aliases: [],
    file: "horizon/review.svg",
  },
  "rocket": {
    code: "f168",
    aliases: [],
    file: "horizon/rocket.svg",
  },
  "sales-data": {
    code: "f169",
    aliases: [],
    file: "horizon/sales-data.svg",
  },
  "save": {
    code: "f16a",
    aliases: ["floppy-o"],
    file: "horizon/save.svg",
  },
  "search": {
    code: "f16b",
    aliases: ["nav-search"],
    file: "horizon/search.svg",
  },
  "settings": {
    code: "f16c",
    aliases: ["cog"],
    file: "horizon/settings.svg",
  },
  "sftp": {
    code: "f16d",
    aliases: [],
    file: "horizon/sftp.svg",
  },
  "share": {
    code: "f16e",
    aliases: ["nav-share-this-page"],
    file: "horizon/share.svg",
  },
  "sign-out": {
    code: "f16f",
    aliases: ["signout", "nav-logout"],
    file: "horizon/sign-out.svg",
  },
  "skull": {
    code: "f170",
    aliases: [],
    file: "horizon/skull.svg",
  },
  "smile": {
    code: "f171",
    aliases: [],
    file: "horizon/smile.svg",
  },
  "sort-asc": {
    code: "f172",
    aliases: ["table-sort-asc"],
    file: "horizon/sort-asc.svg",
  },
  "sort-desc": {
    code: "f173",
    aliases: ["table-sort-desc"],
    file: "horizon/sort-desc.svg",
  },
  "spent": {
    code: "f174",
    aliases: [],
    file: "horizon/spent.svg",
  },
  "star": {
    code: "f175",
    aliases: ["star"],
    file: "horizon/star.svg",
  },
  "style": {
    code: "f176",
    aliases: [],
    file: "horizon/style.svg",
  },
  "table": {
    code: "f177",
    aliases: [],
    file: "horizon/table.svg",
  },
  "tag-add": {
    code: "f178",
    aliases: [],
    file: "horizon/tag-add.svg",
  },
  "tag-remove": {
    code: "f179",
    aliases: [],
    file: "horizon/tag-remove.svg",
  },
  "tag": {
    code: "f17a",
    aliases: [],
    file: "horizon/tag.svg",
  },
  "template": {
    code: "f17b",
    aliases: [],
    file: "horizon/template.svg",
  },
  "testing": {
    code: "f17c",
    aliases: [],
    file: "horizon/testing.svg",
  },
  "text-version": {
    code: "f17d",
    aliases: [],
    file: "horizon/text-version.svg",
  },
  "th-large": {
    code: "f17e",
    aliases: [],
    file: "horizon/th-large.svg",
  },
  "th-list": {
    code: "f17f",
    aliases: [],
    file: "horizon/th-list.svg",
  },
  "thumbs-down": {
    code: "f180",
    aliases: ["reject"],
    file: "horizon/thumbs-down.svg",
  },
  "thumbs-up": {
    code: "f181",
    aliases: ["approve"],
    file: "horizon/thumbs-up.svg",
  },
  "track": {
    code: "f182",
    aliases: [],
    file: "horizon/track.svg",
  },
  "trash": {
    code: "f183",
    aliases: ["trash-o"],
    file: "horizon/trash.svg",
  },
  "trophy": {
    code: "f184",
    aliases: [],
    file: "horizon/trophy.svg",
  },
  "unlock": {
    code: "f185",
    aliases: [],
    file: "horizon/unlock.svg",
  },
  "unsubscribe": {
    code: "f186",
    aliases: [],
    file: "horizon/unsubscribe.svg",
  },
  "update": {
    code: "f187",
    aliases: [],
    file: "horizon/update.svg",
  },
  "user-add": {
    code: "f188",
    aliases: ["user-plus"],
    file: "horizon/user-add.svg",
  },
  "user-verify": {
    code: "f189",
    aliases: [],
    file: "horizon/user-verify.svg",
  },
  "user": {
    code: "f18a",
    aliases: [],
    file: "horizon/user.svg",
  },
  "users": {
    code: "f18b",
    aliases: [],
    file: "horizon/users.svg",
  },
  "versions": {
    code: "f18c",
    aliases: [],
    file: "horizon/versions.svg",
  },
  "warning": {
    code: "f18d",
    aliases: [],
    file: "horizon/warning.svg",
  },
  "wishlist": {
    code: "f18e",
    aliases: [],
    file: "horizon/wishlist.svg",
  },
  "wrench": {
    code: "f18f",
    aliases: [],
    file: "horizon/wrench.svg",
  },
  "logo-google-analytics": {
    code: "f190",
    aliases: [],
    file: "horizon/logo-google-analytics.svg",
  },
  "logo-x": {
    code: "f191",
    aliases: [],
    file: "horizon/logo-x.svg",
  },
  "wallet": {
    code: "f192",
    aliases: [],
    file: "horizon/wallet.svg",
  },
  "logo-sinch-engage": {
    code: "f193",
    aliases: ["ac-logo-sinch-engage"],
    file: "horizon/logo-sinch-engage.svg",
  },
};
